import React from "react"
import { classNames } from "../../utils/helpers"
import Box, { BoxProps } from "../Box"

export interface CardContainerProps extends BoxProps {
  /** ReactNode to be rendered at the very top of the card */
  header?: React.ReactNode
  horizontalOnDesktop?: boolean
  reverse?: boolean
  forceHeight?: boolean
  narrow?: boolean
}

const CardContainer = ({
  children,
  header,
  className,
  horizontalOnDesktop,
  reverse,
  narrow,
  forceHeight = true,
  ...rest
}: CardContainerProps) => {
  return (
    <Box
      className={classNames(
        "border text-left rounded-[20px] overflow-hidden shadow-none isolate",
        (horizontalOnDesktop || reverse) && "flex flex-col",
        horizontalOnDesktop && reverse && "md:flex-row-reverse",
        horizontalOnDesktop && !reverse && "md:flex-row",
        !horizontalOnDesktop && reverse && "flex-col-reverse",
        className
      )}
      {...rest}
    >
      {header ? (
        <Box
          className={classNames(
            "flex items-center justify-center overflow-hidden",
            forceHeight ? "h-screen" : "h-max",
            forceHeight && "max-h-72",
            horizontalOnDesktop && "md:flex-1",
            // horizontalOnDesktop && forceHeight && "md:max-h-96",
            horizontalOnDesktop && forceHeight && "md:max-h-[450px]"
          )}
        >
          {header}
        </Box>
      ) : null}
      <Box
        className={classNames(
          "p-6 flex flex-col gap-6",
          // horizontalOnDesktop && "md:basis-96",
          horizontalOnDesktop && !narrow && "md:basis-1/2",
          horizontalOnDesktop && narrow && "md:basis-1/2 lg:basis-[calc(25%-0.5rem)]",
          horizontalOnDesktop && forceHeight && "md:max-h-[450px] flex-1 md:flex-none"
        )}
      >
        {children}
      </Box>
    </Box>
  )
}

export default CardContainer
